"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Network = exports.REQUEST_FAILED = void 0;
var constants_1 = require("../constants");
var log_1 = require("../utils/log");
var request_1 = require("./request");
var retry_1 = require("./retry");
exports.REQUEST_FAILED = -999;
var Network = (function () {
    function Network(config) {
        var _a;
        this.inited = false;
        this.de_app_id = config.de_app_id;
        this.secret_key = config.secret_key;
        this.host = config.report_host || ((_a = constants_1.host[config.env]) !== null && _a !== void 0 ? _a : constants_1.host.test);
    }
    Network.prototype.getReportDataUrl = function () {
        return "" + this.host + constants_1.API_PREFIX + "/" + this.de_app_id + "/signature";
    };
    Network.prototype.sendRequest = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.sendPlainData(props)];
            });
        });
    };
    Network.prototype.sendPlainData = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var doRequest;
            var _this = this;
            return __generator(this, function (_a) {
                doRequest = function () { return __awaiter(_this, void 0, void 0, function () {
                    var reportData, _a, pageUnload, url, res;
                    return __generator(this, function (_b) {
                        switch (_b.label) {
                            case 0:
                                reportData = props.reportData, _a = props.pageUnload, pageUnload = _a === void 0 ? false : _a;
                                url = this.getReportDataUrl();
                                if (!request_1.APIs.supportFetchKeepAlive) return [3, 2];
                                return [4, request_1.APIs.fetchPost({
                                        url: url,
                                        data: reportData,
                                        apiKey: this.secret_key,
                                    })];
                            case 1:
                                res = _b.sent();
                                log_1.Logger.info("[APMS] post successfully - event_id " + (res === null || res === void 0 ? void 0 : res.event_id));
                                return [2, res];
                            case 2:
                                if (pageUnload) {
                                    return [2, exports.REQUEST_FAILED];
                                }
                                return [2, request_1.APIs.postXHR({
                                        url: url,
                                        data: reportData,
                                        apiKey: this.secret_key,
                                        async: !pageUnload,
                                    })];
                        }
                    });
                }); };
                return [2, (0, retry_1.retry)(doRequest)];
            });
        });
    };
    Network.prototype.sendBulk = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2, this.sendPlainBulk(props)];
            });
        });
    };
    Network.prototype.sendPlainBulk = function (props) {
        return __awaiter(this, void 0, void 0, function () {
            var doRequest;
            var _this = this;
            return __generator(this, function (_a) {
                doRequest = function () { return __awaiter(_this, void 0, void 0, function () {
                    var resArr;
                    var _this = this;
                    return __generator(this, function (_a) {
                        resArr = props.map(function (data) {
                            return _this.sendPlainData({ reportData: data });
                        });
                        return [2, Promise.all(resArr)];
                    });
                }); };
                return [2, (0, retry_1.retry)(doRequest)];
            });
        });
    };
    return Network;
}());
exports.Network = Network;
